export default __webpack_public_path__ + "static/media/alex_pcr_product_a.fd605670.svg";